import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const BasicFullImageHTML: FC = () => {
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);

  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const bgVideo = useSelector((state: RootState) => state.imageUpload.bgVideo);
  const switchMediaType = useSelector(
    (state: RootState) => state.switchButton.switchMediaType
  );
  const btnFontLeftURL = getFontURL(btnFontFamily?.left_button);
  const btnFontRightURL = getFontURL(btnFontFamily?.right_button);

  const style = `
  @font-face {
    font-family: 'btnFontLeft';
    src: url(${btnFontLeftURL});
  }

  @font-face {
    font-family: 'btnFontRight';
    src: url(${btnFontRightURL});
  }

    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;  
      position: relative;
    }
   

    .modal_wrapper {
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding-bottom: 72px;
      background-color: #000000;
      display: flex;
      justify-content: center;      
    }
    .modal_wrapper .inapp_video {
      width: 100%;
      height: 100%;      
      object-fit: contain;      
      object-position: center;
      max-width: 430px;
    }

    .modal_wrapper img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      max-width: 430px;
    }


    .bottom_btn {
      width: 100%;
      height: 72px;
      padding: 16px 36px;
      padding-bottom: 24px;

      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;

      position: absolute;
      bottom: 0;
      background-color:rgba(${btnBgColorR?.left_button},${
    btnBgColorG?.left_button
  }, ${btnBgColorB?.left_button}, ${btnBgColorA?.left_button});
    }

    .bottom_btn button {
      border: 0;
      letter-spacing: 0.36px;
    }
    .bottom_btn .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: left;
      font-size: ${btnFontSize?.left_button}rem;
      font-weight: ${btnFontWeight?.left_button};
      color: ${btnColor?.left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.left_button
        )
          ? btnFontFamily?.left_button
          : 'btnFontLeft'
      };
      background-color: transparent;
    }

    .bottom_btn .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      text-align: right;
      font-size: ${btnFontSize?.right_button}rem;
      font-weight: ${btnFontWeight?.right_button};
      color: ${btnColor?.right_button};
      
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.right_button
        )
          ? btnFontFamily?.right_button
          : 'btnFontRight'
      };
      background-color: transparent;
    }
      
  }    
  `;
  let mediaWrapperHtml = '';
  if (switchMediaType && switchMediaType === 'video') {
    mediaWrapperHtml = `
      <video class="inapp_video" autoplay muted playsinline loop width="100%" height="100%" >
				<source
					src="${bgVideo?.background}"
				/>										
			</video>
    `;
  } else {
    mediaWrapperHtml = `<img src="${bgImage?.background}" alt="bgImage" />`;
  }
  const html = `
    <div class="root">
      <div class="modal_wrapper">
        ${mediaWrapperHtml}
      </div>

      <div class="bottom_btn">
        <button class="style01">
          ${btnText?.left_button}
        </button>
        <button class="style02">
          ${btnText?.right_button}
        </button>
      </div>
    </div>
  `;

  let tracking_list = '[';
  for (let i = 0; i < tracking?.background?.length; i++) {
    tracking_list += `['${tracking?.background?.[i]}', '${tracking?.left_button?.[i]}', '${tracking?.right_button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'BASIC FULL IMAGE',
    button1,
    button2
  );

  const js = `
    document.addEventListener("DOMContentLoaded", function(){
      const tracking = ${tracking_list};
      const button1 = ${tracking_button_list[0]};
      const button2 = ${tracking_button_list[1]};

      document.querySelector('.modal_wrapper').addEventListener('click', function() {
        appboyBridge.logClick(tracking[0][0]);
        try {
          if (button1[0].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[0].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = "${deeplink?.background}";
      });

      document.querySelector('.style01').addEventListener('click', function() {
        try {
          if ("${btnAgain?.type}" === "attribute") {
            appboyBridge.getUser().setCustomUserAttribute("${btnAgain?.left_button}", new Date());
          }
          if ("${btnAgain?.type}" === "event") {
            appboyBridge.logCustomEvent("${btnAgain?.left_button}");            
          }
        } catch (err) {}

        appboyBridge.logClick(tracking[0][1]);
        try {
          if (button1[1].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[1].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
      
      document.querySelector('.style02').addEventListener('click', function() {
        appboyBridge.logClick(tracking[0][2]);
        try {
          if (button1[2].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[2].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
    });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
        <script
          dangerouslySetInnerHTML={{
            __html: `               
         (function () {
          function adjustFontSize() {
            const actualSize = Math.round(parseFloat(window.getComputedStyle(document.documentElement).fontSize));
            if (actualSize !== 16) {              
              const newFontSize = (16 * 16) / actualSize;
              document.documentElement.style.fontSize = newFontSize + "px";                            
            }
          }              
          // adjust font size before body load
          adjustFontSize();
        })();                           
          `
          }}
        />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};

export default BasicFullImageHTML;
